import { render, staticRenderFns } from "./ProspectTestimonialCarousel.vue?vue&type=template&id=62d12295&scoped=true&"
import script from "./ProspectTestimonialCarousel.vue?vue&type=script&lang=js&"
export * from "./ProspectTestimonialCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProspectTestimonialCarousel.vue?vue&type=style&index=0&id=62d12295&scoped=true&lang=css&"
import style1 from "./ProspectTestimonialCarousel.vue?vue&type=style&index=1&id=62d12295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d12295",
  null
  
)

export default component.exports